import { IMenuOption } from "models/interfaces";
import React from "react";

const Message: React.FC<{ menuData: IMenuOption }> = ({ menuData }) => {
  return (
    <React.Fragment>
      <div className="accHead">{menuData.name} (TBD)</div>
      <div className="accBody">asdasd</div>
    </React.Fragment>
  );
};

export default Message;
